import React, { useMemo } from 'react';
import { Dropdown, Menu, Space } from 'antd';
import { Routes } from '../../routing/Router';
import { useNavigate } from 'react-router';
import collect from 'collect.js';
import { DownOutlined } from '@ant-design/icons';
import useAuth from '../../hooks/context/useAuth';

export default function Header() {
  const navigate = useNavigate();
  const { user, logOut } = useAuth();

  const items = [
    { key: Routes.NewOrder.Root, label: 'Customer Ordering' },
    { key: Routes.Orders, label: 'Orders dashboard' },
    { key: Routes.Restaurants, label: 'Restaurants' },
    { key: Routes.BlockedNumbers, label: 'Blocked Numbers' },
  ];

  const current = useMemo(
    () =>
      (
        collect(items).firstWhere('key', window.location.pathname) ??
        collect(items).firstWhere('key', window.location.pathname.slice(1)) ??
        collect(items).firstWhere('key', window.location.pathname.slice(1).split('/')[0])
      )?.key,
    [window.location.pathname],
  );

  const dropdownItems = [{ key: 'logout', label: 'Log out', onClick: logOut }];

  return (
    <header id="header" className="w-full flex justify-between pr-sm border-b">
      <Menu
        mode="horizontal"
        items={items}
        selectedKeys={[current]}
        onClick={(item) => navigate(`/${item.key}`)}
        className="border-none"
      />
      <Dropdown menu={{ items: dropdownItems }} className="my-auto">
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            {user?.name}
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </header>
  );
}
